import { contentPrinciples } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {contentPrinciples.map((item) => (
        <article key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
            <i className={`${item.icon} text-2xl`}></i>
          </span>
          <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
          <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
        </article>
      ))}
    </div>
  );
}